import React, { useEffect, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import "./index.scss";
import axios from "axios";
import { Link } from "react-router-dom";
import { LangContext } from "../../context/LangContext";
const TopBar = ({ closeMobileNav }) => {
  const lang = React.useContext(LangContext);
  const nep = lang.state.np;
  const onClickNP = () => {
    lang.dispatch({ type: "NEPALI" });
  };
  const onClickEN = () => {
    lang.dispatch({ type: "ENGLISH" });
  };
  const [menu, setMenu] = React.useState();
  const MianData = useState([]);
  const APIURL = `${process.env.REACT_APP_URL}menu/top`;
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  useEffect(() => {
    const LangBtnLink = document.querySelectorAll(".LangBtn");
    LangBtnLink.forEach((LangBtnEl) => {
      LangBtnEl.addEventListener("click", () => {
        document.querySelector(".active")?.classList.remove("active");
        LangBtnEl.classList.add("active");
      });
    });
  });

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setMenu(response.data.items);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    })();
  }, []);
  if (nep) {
    MianData.current = menu?.np;
  } else {
    MianData.current = menu?.en;
  }
  if (loading) return "...";
  if (error) return "";

  return (
    <>
      <ul className="TopMenuItems">
        {MianData.current.map((menu) => {
          return (
            <>
              {typeof menu.child === "undefined" ? (
                <li key={menu.id}>
                  {menu.link === "" ? (
                    <Link to={menu.slug} onClick={closeMobileNav}>
                      {menu.title}
                    </Link>
                  ) : (
                    <Link
                      to={menu.link}
                      onClick={closeMobileNav}
                      target="_blank"
                    >
                      {menu.title}
                    </Link>
                  )}
                </li>
              ) : (
                <li key={menu.id} className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to={"#"}
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    {menu.title}
                  </Link>
                  <ul className="dropdown-menu" role="menu">
                    {menu.child.map((child) => {
                      switch (menu.slug) {
                        case "grievance":
                          return (
                            <>
                              <li key={child.id}>
                                {child.link === "" ? (
                                  <Link
                                    onClick={closeMobileNav}
                                    className="dropdown-item"
                                    to={`grievance/${child.slug}`}
                                  >
                                    {child.title}
                                  </Link>
                                ) : (
                                  <Link
                                    onClick={closeMobileNav}
                                    className="dropdown-item"
                                    to={child.link}
                                    target="_blank"
                                  >
                                    {child.title}
                                  </Link>
                                )}
                              </li>
                            </>
                          );
                          break;
                        default:
                          return (
                            <>
                              <li key={child.id}>
                                {child.link === "" ? (
                                  <Link
                                    onClick={closeMobileNav}
                                    className="dropdown-item"
                                    to={child.slug}
                                  >
                                    {child.title}
                                  </Link>
                                ) : (
                                  <Link
                                    onClick={closeMobileNav}
                                    className="dropdown-item"
                                    to={child.link}
                                    target="_blank"
                                  >
                                    {child.title}
                                  </Link>
                                )}
                              </li>
                            </>
                          );
                      }
                    })}
                  </ul>
                </li>
              )}
            </>
          );
        })}
      </ul>
      <div className="ActionBox">
        <div className="language" role="radiogroup" aria-label="Language selection">
          <ul>
            <li
              className={`LangBtn ${!nep ? "active" : ""}`}
              onClick={() => { onClickEN(); }}
              role="radio"
              aria-checked={!nep}
              tabIndex={!nep ? "0" : "-1"}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClickEN(); return; }
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); document.querySelector('.LangBtn.nepali')?.focus(); onClickNP(); }
                if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); }
              }}
            >
              En
            </li>
            <li
              className="LangBtn nepali"
              onClick={() => { onClickNP(); }}
              role="radio"
              aria-checked={nep}
              tabIndex={nep ? "0" : "-1"}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClickNP(); return; }
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); }
                if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); document.querySelector('.LangBtn.active')?.focus(); onClickEN(); }
              }}
            >
              ने
            </li>
          </ul>
        </div>
        <div className="LoginBox">
          <a
            href="https://ebanking.gmbf.com.np/ebank/#/"
            target="_blank"
            rel="noopener noreferrer"
            className="a11y-login-link"
            onClick={closeMobileNav}
            aria-label={nep ? "ई-लगइन" : "e-Login"}
          >
            <AccountCircleIcon fontSize="small" aria-hidden="true" />{" "}
            {nep ? "ई-लगइन" : "e-Login"}
          </a>
        </div>
        <div className="SearchBox">
          <Link to={"search"} onClick={closeMobileNav} aria-label="Search">
            <SearchIcon fontSize="small" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </>
  );
};
export default TopBar;
